import {lottieAnimation} from "./lottie-animation.js";

export const fullpageScroll = ()=> {
    //lottie

    const lotties = document.querySelectorAll('.info__lottie');

    const lottieArray = [...lotties]?.map(animation=> {
        const path = animation.getAttribute('data-path');

        let lottieInstance

        if (path) {
            lottieInstance = lottie.loadAnimation({
                container: animation,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: path
            });

            return lottieInstance;

        }
    })

    //scroll

    if (document.querySelector('body').classList.contains('home')) {

        const sections = document.querySelectorAll("section");
        const sectionsWrapper = document.getElementById("panelWrap");
        const dots = document.querySelector(".dots");

        const btn = document.querySelector('.hero__mouse-scroll');

        //listeners

        document.addEventListener("wheel", handleWheel);
        addEventListener("resize",newSize);
        btn?.addEventListener('click',scrollToNextSection)

        let listening = false,
            direction = "down",
            current,
            next = 0;

        for (let i = 0; i < sections.length; i++) {
            let dotWrapper = document.createElement("div");
            dotWrapper.className = "dot-wrapper";
            dotWrapper.index = i;
            dotWrapper.addEventListener("click", dotScroll);
            dots.appendChild(dotWrapper);

            let newDot = document.createElement("div");
            newDot.className = "dot";
            dotWrapper.appendChild(newDot);
        }

        // resize function

        function newSize() {
            if (window.innerWidth < 1024) {
                current = 0
                next = 0
                // gsap.set(sectionsWrapper, { yPercent: 0 });
                sectionsWrapper.style = `transform: translateY(0%))`

                dots.querySelectorAll('.dot').forEach(dot=> {
                    dot.classList.remove('active')
                })
                dots.querySelectorAll('.dot')[0].classList.add('active')
            }
        }

        function dotScroll() {
            current = this.index
            next = this.index + 1
            console.log(this)
            // gsap.timeline({
            //     defaults: tlDefaults,
            // })
            // .to(sectionsWrapper, { yPercent: -(current * 100) }, 0)
            console.log(-(current * 100))
            sectionsWrapper.style = `transform: translateY(${-(current * 100)}%)`

            dots.querySelectorAll('.dot').forEach(dot=> {
                dot.classList.remove('active')
            })
            this.querySelector('.dot').classList.add('active')

        }


    // Slides a section in on scroll down
        function slideIn() {
            if (current === undefined) {
                dots.querySelectorAll('.dot')[0].classList.add('active')

                // const tl = gsap.timeline({
                //     onComplete: () => {
                //         listening = true;
                //         current = next;
                //     }
                // })
                // .to(sectionsWrapper, { yPercent: 0 }, 0)
                //
                // tl.play(0);

                sectionsWrapper.style = `transform: translateY(0%)`

                setTimeout(()=> {
                    listening = true;
                    current = next;
                },1250)

            }

            if (current !== undefined) {
                // gsap.timeline({
                //     defaults: tlDefaults,
                //     onStart: () => {
                //         lottieArray?.forEach(item=> {
                //             item.pause();
                //         })
                //     },
                //     onComplete: () => {
                //         listening = true;
                //         current = next;
                //         lottieArray?.forEach(item=> {
                //             item.play();
                //         })
                //     }
                // })
                // .to(sectionsWrapper, { yPercent: -(next * 100) }, 0)

                sectionsWrapper.style = `transform: translateY(${-(next * 100)}%)`

                lottieArray?.forEach(item=> {
                    item.pause();
                })

                setTimeout(()=> {
                    listening = true;
                    current = next;
                    lottieArray?.forEach(item=> {
                        item.play();
                    })
                },1250)

                // add class for active dot

                dots.querySelectorAll('.dot').forEach(dot=> {
                    dot.classList.remove('active')
                })
                dots.querySelectorAll('.dot')[next].classList.add('active')

            }

        }

    // Slides a section out on scroll up
        function slideOut() {
            // gsap.timeline({
            //         defaults: tlDefaults,
            //         onStart: () => {
            //             lottieArray?.forEach(item=> {
            //                 item.pause();
            //             })
            //         },
            //         onComplete: () => {
            //             listening = true;
            //             current = next;
            //             lottieArray?.forEach(item=> {
            //                 item.play();
            //             })
            //         }
            //     })
            //     .to(sectionsWrapper, { yPercent: -(next * 100) }, 0)

            sectionsWrapper.style = `transform: translateY(${-(next * 100)}%)`

            lottieArray?.forEach(item=> {
                item.pause();
            })

            setTimeout(()=> {
                listening = true;
                current = next;
                lottieArray?.forEach(item=> {
                    item.play();
                })
            },1250)
            // add class for active dot

            dots.querySelectorAll('.dot').forEach(dot=> {
                dot.classList.remove('active')
            })
            dots.querySelectorAll('.dot')[next].classList.add('active')

        }

        function handleDirection() {

            listening = false;

            if (direction === "down") {
                if( current !== sections.length - 1) {
                    next = current + 1;
                    slideIn();
                } else {
                    listening = true;
                }
            }

            if (direction === "up") {
                if( current !== 0) {
                    next = current - 1;
                    slideOut();
                } else {
                    listening = true;
                }
            }

        }

        function handleWheel(e) {
            if (window.innerWidth < 1024) {
                return
            }
            if (!listening) {
                return
            }
            direction = e.wheelDeltaY < 0 ? "down" : "up";
            handleDirection();
        }

        function scrollToNextSection() {
            if (window.innerWidth < 1024) {
                const nextSectionOffset = btn.closest('section').nextElementSibling?.offsetTop;

                window.scrollTo({
                    top: nextSectionOffset,
                    behavior: "smooth",
                });
            } else {
                current = 1
                next = 1

                dots.querySelectorAll('.dot').forEach(dot=> {
                    dot.classList.remove('active')
                })
                dots.querySelectorAll('.dot')[current].classList.add('active')

                // gsap.timeline({
                //     defaults: tlDefaults,
                // }).to(sectionsWrapper, { yPercent: -100 }, 0);
                sectionsWrapper.style = `transform: translateY(${-100}%)`

            }

        }

        slideIn();
    }

}